module.exports = __webpack_public_path__ + "img/logotyp-per.be18a261.jpg";